import api from './axios';

const userService = {
  // Получение информации о пользователе
  async getUserInfo() {
    try {
      const response = await api.get('/auth/get_user_info');
      return response.data.data || response.data; // Поддержка нового формата API
    } catch (error) {
      console.error('Ошибка при получении информации о пользователе:', error);
      // Пробрасываем ошибку с нормализованным сообщением
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Получение только динамических данных о токенах
  async getUserTokens() {
    try {
      const response = await api.get('/auth/get_user_tokens');
      return response.data.data || response.data; // Поддержка нового формата API
    } catch (error) {
      console.error('Ошибка при получении данных о токенах:', error);
      // Пробрасываем ошибку с нормализованным сообщением
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Получение профиля пользователя
  async getUserProfile() {
    try {
      const response = await api.get('/auth/get_user_profile');
      return response.data.data || response.data; // Поддержка нового формата API
    } catch (error) {
      console.error('Ошибка при получении профиля пользователя:', error);
      // Пробрасываем ошибку с нормализованным сообщением
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  async updateProfile(payload) {
    try {
      const response = await api.patch('/auth/update_profile', payload);
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при сохранении профиля:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      enhancedError.errors = error.response?.data?.errors;
      throw enhancedError;
    }
  },

  // Получение списка всех пользователей (для админа)
  async getAllUsers(params) {
    try {
      const response = await api.get('/admin/users', { params });
      return response.data.data || response.data; // Поддержка нового формата API
    } catch (error) {
      console.error('Ошибка при получении списка пользователей:', error);
      // Пробрасываем ошибку с нормализованным сообщением
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Подтверждение пользователя (для админа)
  async confirmUser(userId) {
    try {
      const response = await api.post(`/admin/confirm_user/${userId}`);
      return response.data.data || response.data; // Поддержка нового формата API
    } catch (error) {
      console.error('Ошибка при подтверждении пользователя:', error);
      // Пробрасываем ошибку с нормализованным сообщением
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Обновление роли пользователя (для админа)
  async updateUserRole(userId, roleId) {
    try {
      const response = await api.put(`/admin/users/${userId}/role`, { role_id: roleId });
      return response.data.data || response.data; // Поддержка нового формата API
    } catch (error) {
      console.error('Ошибка при обновлении роли пользователя:', error);
      // Пробрасываем ошибку с нормализованным сообщением
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Обновление подписки пользователя (для админа)
  async updateUserSubscription(userId, subscriptionData) {
    try {
      const response = await api.put(`/admin/users/${userId}/subscription`, subscriptionData);
      return response.data.data || response.data; // Поддержка нового формата API
    } catch (error) {
      console.error('Ошибка при обновлении подписки пользователя:', error);
      // Пробрасываем ошибку с нормализованным сообщением
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  async getUserTokenUsage(params = {}) {
    try {
      const response = await api.get('/analytics/token-usage', { params });
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при получении истории токенов пользователя:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  async getUserActivity(params = {}) {
    try {
      const response = await api.get('/analytics/activity', { params });
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при получении истории действий пользователя:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Получение настроек парсеров (для админа)
  async getParserSettings() {
    try {
      const response = await api.get('/admin/parsers/settings');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при получении настроек парсеров:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Обновление настроек парсеров (для админа)
  async updateParserSettings(settings) {
    try {
      const response = await api.put('/admin/parsers/settings', settings);
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при обновлении настроек парсеров:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // ============================================================================
  // GOSZAKUP PARSER (для админа)
  // ============================================================================

  // Получение статуса парсера Goszakup
  async getGoszakupParserStatus() {
    try {
      const response = await api.get('/admin/goszakup/status');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при получении статуса парсера Goszakup:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Запуск парсера Goszakup вручную
  async triggerGoszakupParser() {
    try {
      const response = await api.post('/admin/goszakup/trigger');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при запуске парсера Goszakup:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // ============================================================================
  // ETP IMPORT (для админа)
  // ============================================================================

  // Запуск импорта ETP вручную
  async triggerEtpImport() {
    try {
      const response = await api.post('/admin/etp/import');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при запуске импорта ETP:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Получение статуса импорта ETP
  async getEtpStatus() {
    try {
      const response = await api.get('/admin/etp/status');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при получении статуса ETP:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // ============================================================================
  // SUPPLIER IMPORT (для админа)
  // ============================================================================

  // Импорт поставщиков из Excel
  async importSuppliersExcel(formData) {
    try {
      const response = await api.post('/admin/suppliers/import', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при импорте поставщиков:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Предпросмотр импорта поставщиков из Excel
  async previewSuppliersImport(formData) {
    try {
      const response = await api.post('/admin/suppliers/import/preview', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при предпросмотре импорта поставщиков:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Подтверждение импорта поставщиков
  async confirmSuppliersImport(formData) {
    try {
      const response = await api.post('/admin/suppliers/import', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при подтверждении импорта поставщиков:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // ============================================================================
  // PARSER TRIGGERS & STATS
  // ============================================================================

  // Запуск конкретного парсера вручную
  async triggerParser(parserName) {
    try {
      const response = await api.post('/admin/parsers/trigger', { parser_name: parserName });
      return response.data.data || response.data;
    } catch (error) {
      console.error(`Ошибка при запуске парсера ${parserName}:`, error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Запуск импорта E-ondiris вручную
  async triggerEondirisImport() {
    try {
      const response = await api.post('/admin/eondiris/import');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при запуске импорта E-ondiris:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Запуск переиндексации лотов MITWORK вручную
  async triggerMitworkSync() {
    try {
      const response = await api.post('/admin/mitwork/sync');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при запуске переиндексации MITWORK:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Запуск импорта Asianet вручную
  async triggerAsianetImport() {
    try {
      const response = await api.post('/admin/asianet/import');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при запуске импорта Asianet:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Запуск синхронизации поставщиков вручную
  async triggerSuppliersSync() {
    try {
      const response = await api.post('/admin/suppliers/sync');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при запуске синхронизации поставщиков:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Запуск переиндексации suppliers вручную (в фоне)
  async triggerSuppliersReindex() {
    try {
      const response = await api.post('/admin/suppliers/reindex');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при запуске переиндексации suppliers:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Получение статуса фоновой переиндексации suppliers
  async getSuppliersReindexStatus() {
    try {
      const response = await api.get('/admin/suppliers/reindex/status');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при получении статуса переиндексации suppliers:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  /** Фоновая переиндексация goszakup_plans в Elasticsearch */
  async triggerGoszakupPlansReindex(forceRecreate = false) {
    try {
      const response = await api.post('/admin/goszakup/plans-reindex', {
        force_recreate: forceRecreate
      });
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при запуске переиндексации планов (ES):', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  async getGoszakupPlansReindexStatus() {
    try {
      const response = await api.get('/admin/goszakup/plans-reindex/status');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при получении статуса переиндексации планов (ES):', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  /** Полная переиндексация выбранных источников Elasticsearch (фон). */
  async triggerEsReindex(sources, forceRecreate = false) {
    try {
      const response = await api.post('/admin/elasticsearch/reindex', {
        sources,
        force_recreate: forceRecreate,
      });
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при запуске ES-переиндексации:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  async getEsReindexStatus() {
    try {
      const response = await api.get('/admin/elasticsearch/reindex/status');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при получении статуса ES-переиндексации:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Очередь фоновых задач (RQ): воркеры, выполняемые и упавшие задачи
  async getTaskQueueStatus() {
    try {
      const response = await api.get('/admin/task-queue/status');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при получении статуса очереди задач:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  async requeueFailedTask(jobId) {
    try {
      const response = await api.post(`/admin/task-queue/failed/${encodeURIComponent(jobId)}/requeue`);
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при перезапуске задачи:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Получение статистики парсеров
  async getParserStats() {
    try {
      const response = await api.get('/admin/parsers/stats');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при получении статистики парсеров:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // ============================================================================
  // BIN ENRICHMENT (для админа)
  // ============================================================================

  // Запуск обогащения БИН вручную
  async triggerBinEnrichment() {
    try {
      const response = await api.post('/admin/bin-enrichment/trigger');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при запуске обогащения БИН:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Получение статуса обогащения БИН
  async getBinEnrichmentStatus() {
    try {
      const response = await api.get('/admin/bin-enrichment/status');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при получении статуса обогащения БИН:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Ручной запуск синхронизации РНУ (недобросовестные поставщики)
  async triggerUnreliableSuppliersSync() {
    try {
      const response = await api.post('/admin/unreliable-suppliers/sync');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при запуске синхронизации РНУ:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  },

  // Статистика РНУ
  async getUnreliableSuppliersStatus() {
    try {
      const response = await api.get('/admin/unreliable-suppliers/status');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Ошибка при получении статистики РНУ:', error);
      const message = error._meta?.message || error.response?.data?.message || error.message;
      const enhancedError = new Error(message);
      enhancedError._meta = error._meta;
      enhancedError.response = error.response;
      throw enhancedError;
    }
  }
};

export default userService; 
